import { FIRST_ARRAY_ELEMENT } from '@/constants/common';
import { PNG_IMAGE_HANDLER_NAME_ID } from '@/redux/configuration/configuration.constants';
import { useContext } from 'react';
import { ExportContext } from '../ExportCompound.context';

export const ImageExportNotice = (): React.ReactNode => {
  const { data } = useContext(ExportContext);
  const isPng = data.imageFormats?.[FIRST_ARRAY_ELEMENT]?.label === PNG_IMAGE_HANDLER_NAME_ID;

  return (
    <div
      className={`mt-4 text-xs text-font-400 ${data.graphicsMapToggle ? 'hidden' : 'visible'}`}
      data-testid="image-export-notice"
    >
      <p>Overlays will be exported if active.</p>
      {isPng && (
        <p className="mt-2">
          Reduce the image size by manipulating &apos;Image size&apos; parameters above. For higher
          resolution &apos;png&apos; images, export the diagram in &apos;svg&apos; and convert it to
          the desired resolution.
        </p>
      )}
    </div>
  );
};
